import BaseComponent from '../base/baseComponent';
export default class collectionIntroTabs extends BaseComponent {
    constructor(element) {
        super(element);
        this.isDesktop = window.isDesktop();
        this.initComponent();
        this.collectionComponents = this.$el.querySelectorAll('.inpage-collection-component');
    }
    initComponent() {
        // const $toggleCollections = this.$el.querySelectorAll('.inpage-collection__toggle-icon');
        const $collectionBoxes = this.$el.querySelectorAll('.inpage-collection');
        const $container = this.$el;
        if (window.innerWidth >= 1200) {
            $collectionBoxes.forEach((el) => {
                this.$on('mouseenter', (e) => this.toggleCollection(e, el), el);
                this.$on('mouseleave', (e) => {
                    // if (e.currentTarget !== e.target) return;
                    // if (e.target.closest('.inpage-collection')) return;
                    $container.classList.remove('collection-open');
                    $collectionBoxes.forEach((box) => {
                        var _a;
                        box.classList.remove('expanded');
                        (_a = box.querySelector('button[aria-expanded]')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'false');
                    });
                    this.collectionComponents.forEach((component) => {
                        component.classList.remove('resized');
                        component.classList.remove('opened');
                    });
                }, el);
            });
        }
        $collectionBoxes.forEach((el) => {
            el.addEventListener('click', (e) => this.toggleCollection(e));
            // this.$on('click', (e) => this.toggleCollection(e, el, this.isDesktop), el);
        });
        // $toggleCollections.forEach((el) => {
        //   this.$on('click', (e) => this.toggleCollection(e, el, false), el);
        // });
    }
    toggleCollection(e, el, isDesktop) {
        var _a, _b;
        const target = e.target;
        if (!target.classList.contains('button'))
            e.preventDefault();
        const $container = this.$el;
        // const currentCollectionBox = el.closest('.inpage-collection');
        const currentCollectionBox = e.currentTarget;
        // console.log(e);
        if (currentCollectionBox.classList.contains('expanded') && window.innerWidth >= 1200)
            return;
        const collectionBox = this.$el.querySelectorAll('.inpage-collection');
        collectionBox.forEach((box) => {
            var _a;
            if (box !== currentCollectionBox) {
                box.classList.remove('expanded');
                (_a = box.querySelector('button[aria-expanded]')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'false');
            }
        });
        this.collectionComponents.forEach((component) => {
            if (component.querySelector('.inpage-collection') !== currentCollectionBox) {
                component.classList.add('resized');
                component.classList.remove('opened');
            }
            else {
                component.classList.remove('resized');
                component.classList.add('opened');
            }
        });
        if (currentCollectionBox.classList.contains('expanded')) {
            currentCollectionBox.classList.remove('expanded');
            (_a = currentCollectionBox.querySelector('button[aria-expanded]')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'false');
            $container.classList.remove('collection-open');
        }
        else {
            $container.classList.add('collection-open');
            currentCollectionBox.classList.add('expanded');
            (_b = currentCollectionBox.querySelector('button[aria-expanded]')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-expanded', 'true');
        }
    }
}
